<template>
  <Head>
    <title v-if="meta.title">{{ meta.title }}</title>
    <meta v-if="meta.description" name="description" :content="meta.description" />
    <meta v-if="meta.keywords" name="keywords" :content="meta.keywords" />

    <meta
      v-for="(value, property) in openGraph.properties"
      v-bind:key="property"
      :property="openGraph.prefix + property"
      :content="value"
    />
  </Head>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue';
import { getSeoFromRouteName } from '@/lego/utils/route/seo';

export default {
  components: {
    Head,
  },
  setup(props, { root }) {
    const routeName = root.$page.props.route.name;
    const { meta, openGraph } = getSeoFromRouteName(routeName);

    return {
      meta,
      openGraph,
    };
  },
};
</script>
